import "react-app-polyfill/ie9";
import "core-js/es/map";
import "core-js/es/set";
import "raf/polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./css/index.css";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import lightBlue from "@material-ui/core/colors/lightBlue";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import ReduxPromise from "redux-promise";
import ReduxThunk from "redux-thunk";
import reducers from "./reducers";
import Promise from "babel-polyfill";
// To add to window  解决promise 在ie中未定义的问题
if (!window.Promise) {
  window.Promise = Promise;
}

const createStoreWithMiddleware = applyMiddleware(ReduxPromise, ReduxThunk)(
  createStore
);
const materialTheme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#259083"
      }
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: 'white',
      }
    },
    MuiPickersDay: {
      day: {
        color: "#259083",
        "&$selected": {
          backgroundColor: "#259083"
        }
      },
      current: {
        color: "#259083"
      }
    },
    MuiPickersModal: {
      dialogAction: {
        color: "#259083"
      }
    },
    MuiPaper: {
      elevation1: {
        boxShadow: "none"
      }
    } //首页手风琴的阴影
  }
});
ReactDOM.render(
  <MuiThemeProvider theme={materialTheme}>
    <Provider store={createStoreWithMiddleware(reducers)}>
      <App />
    </Provider>
  </MuiThemeProvider>,
  document.getElementById("root")
);
